/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1ExamIdMutationResponse,
  DeleteApiV1ExamIdPathParams,
  DeleteApiV1ExamId400,
  DeleteApiV1ExamId401,
  DeleteApiV1ExamId404,
  DeleteApiV1ExamId500,
} from "../../types/examEvaluationController/DeleteApiV1ExamId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1ExamId } from "../../clients/examEvaluationController/deleteApiV1ExamId.ts";

export const deleteApiV1ExamIdMutationKey = () =>
  [{ url: "/api/v1/exam/:id" }] as const;

export type DeleteApiV1ExamIdMutationKey = ReturnType<
  typeof deleteApiV1ExamIdMutationKey
>;

export function deleteApiV1ExamIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteApiV1ExamIdMutationKey();
  return mutationOptions<
    DeleteApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamId400
      | DeleteApiV1ExamId401
      | DeleteApiV1ExamId404
      | DeleteApiV1ExamId500
    >,
    { id: DeleteApiV1ExamIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1ExamId(id, config);
    },
  });
}

/**
 * @description Remove uma prova. Quando a prova possui publicações vinculadas, realiza exclusão lógica (desativa o registro). Caso contrário, realiza exclusão física em cascata, removendo questões, idiomas e a prova. **(Requer Authorization para autenticação)**
 * @summary Excluir prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:id}
 */
export function useDeleteApiV1ExamId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1ExamIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1ExamId400
        | DeleteApiV1ExamId401
        | DeleteApiV1ExamId404
        | DeleteApiV1ExamId500
      >,
      { id: DeleteApiV1ExamIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1ExamIdMutationKey();

  const baseOptions = deleteApiV1ExamIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamId400
      | DeleteApiV1ExamId401
      | DeleteApiV1ExamId404
      | DeleteApiV1ExamId500
    >,
    { id: DeleteApiV1ExamIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamId400
      | DeleteApiV1ExamId401
      | DeleteApiV1ExamId404
      | DeleteApiV1ExamId500
    >,
    { id: DeleteApiV1ExamIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamId400
      | DeleteApiV1ExamId401
      | DeleteApiV1ExamId404
      | DeleteApiV1ExamId500
    >,
    { id: DeleteApiV1ExamIdPathParams["id"] },
    TContext
  >;
}
